import { App as AntApp, ConfigProvider } from "antd";
import jaJP from "antd/locale/ja_JP";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Provider as UrqlProvider } from "urql";
import { AuthProvider } from "visumo-data-agent-web-shared";

import { bootstrap } from "./app-config";
import { routes } from "./router";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root が見つかりません");
}
const root = createRoot(container);
const result = bootstrap();

if (!result.ok) {
  root.render(
    <StrictMode>
      <div className="vd-login">
        <div className="vd-login-card">
          <h1>設定が足りません</h1>
          <p>
            ビルド時に次の環境変数が必要です。設定し直してビルドしてください。
          </p>
          <ul>
            {result.missing.map((key) => (
              <li key={key}>
                <code>{key}</code>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </StrictMode>,
  );
} else {
  root.render(
    <StrictMode>
      <ConfigProvider locale={jaJP}>
        <AntApp>
          <AuthProvider session={result.session}>
            <UrqlProvider value={result.client}>
              <RouterProvider router={createBrowserRouter(routes)} />
            </UrqlProvider>
          </AuthProvider>
        </AntApp>
      </ConfigProvider>
    </StrictMode>,
  );
}
